import { encode } from "@googlemaps/polyline-codec";
import { Loader } from "@googlemaps/js-api-loader";

export const getMapSnapshotUrl = async ({
  startLocation,
  endLocation,
  googleMapsApiKey,
}) => {
  const loader = new Loader({
    apiKey: googleMapsApiKey,
    libraries: ["places"],
  });

  try {
    await loader.load();
  } catch (err) {
    console.error("Google Maps API failed to load.", err);
    return null;
  }

  const directionsService = new window.google.maps.DirectionsService();

  return new Promise((resolve, reject) => {
    directionsService.route(
      {
        origin: startLocation,
        destination: endLocation,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        console.log("Directions status:", status);
        if (status === "OK" && result) {
          const route = result.routes[0];
          const leg = route.legs[0];
          const distance = leg?.distance?.value || 0;

          const overviewPath = route.overview_path.map((point) => [
            point.lat(),
            point.lng(),
          ]);
          const encodedPolyline = encode(overviewPath);

          const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?size=600x300&maptype=roadmap` +
            `&markers=color:green|label:S|${startLocation.lat},${startLocation.lng}` +
            `&markers=color:red|label:E|${endLocation.lat},${endLocation.lng}` +
            `&path=enc:${encodedPolyline}` +
            `&key=${googleMapsApiKey}`;

          console.log("staticMapUrl:", staticMapUrl);

          resolve({
            snapshotUrl: staticMapUrl,
            distance,
          });
        } else {
          console.error("Directions request failed:", status);
          reject(null);
        }
      }
    );
  });
};
